import React from 'react';
import Input from '../../../components/ui/Input';
import Textarea from '../../../components/ui/Textarea';
import {
  CONTENT_GENERATION_MODE_LABELS,
  TIMEZONE_OPTIONS,
} from '../constants';
import RecurringScheduleFields from './RecurringScheduleFields';

function ScheduledMessageFormFields({
  form,
  updateField,
  setFormFields,
  fieldsDisabled,
  idPrefix = 'schedule',
}) {
  return (
    <>
      <section className="space-y-4">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-content-muted">
          Destinatário
        </h3>
        <Input
          id={`${idPrefix}-template`}
          label="Template Botmaker"
          value={form.templateName}
          onChange={updateField('templateName')}
          placeholder="abertura_conversa"
          required
          disabled={fieldsDisabled}
          hint="Intent/template aprovado no Botmaker."
        />
      </section>

      <section className="space-y-4 border-t border-surface-border pt-5">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-content-muted">
          Geração de conteúdo
        </h3>
        <Textarea
          id={`${idPrefix}-generation-instruction`}
          label="Instrução para geração"
          value={form.generationInstruction}
          onChange={updateField('generationInstruction')}
          placeholder="Ex.: Lembre o contato da consulta de amanhã e confirme presença."
          required
          rows={3}
          hint="Orientação mínima para o agente gerar a mensagem proativa."
        />
        <div className="grid gap-4 lg:grid-cols-2">
          <div>
            <p className="block text-sm font-medium text-slate-700 mb-2">Modo de geração</p>
            <div className="flex flex-wrap gap-4">
              {Object.entries(CONTENT_GENERATION_MODE_LABELS).map(([value, label]) => (
                <label key={value} className="inline-flex items-center gap-2 text-sm text-content-primary">
                  <input
                    type="radio"
                    name={`${idPrefix}-contentGenerationMode`}
                    value={value}
                    checked={form.contentGenerationMode === value}
                    onChange={updateField('contentGenerationMode')}
                    disabled={fieldsDisabled}
                  />
                  {label}
                </label>
              ))}
            </div>
          </div>
          {form.contentGenerationMode === 'batch' && (
            <Input
              id={`${idPrefix}-batch-lead`}
              label="Antecedência (dias)"
              type="number"
              min="1"
              value={form.batchLeadDays}
              onChange={updateField('batchLeadDays')}
              disabled={fieldsDisabled}
            />
          )}
        </div>
      </section>

      <section className="space-y-4 border-t border-surface-border pt-5">
        <h3 className="text-xs font-semibold uppercase tracking-wide text-content-muted">
          Agendamento
        </h3>
        <div>
          <p className="block text-sm font-medium text-slate-700 mb-2">Tipo de agenda</p>
          <div className="flex flex-wrap gap-4">
            <label className="inline-flex items-center gap-2 text-sm text-content-primary">
              <input
                type="radio"
                name={`${idPrefix}-scheduleType`}
                value="one_off"
                checked={form.scheduleType === 'one_off'}
                onChange={updateField('scheduleType')}
                disabled={fieldsDisabled}
              />
              Único
            </label>
            <label className="inline-flex items-center gap-2 text-sm text-content-primary">
              <input
                type="radio"
                name={`${idPrefix}-scheduleType`}
                value="recurring"
                checked={form.scheduleType === 'recurring'}
                onChange={updateField('scheduleType')}
                disabled={fieldsDisabled}
              />
              Recorrente
            </label>
          </div>
        </div>

        {form.scheduleType === 'one_off' ? (
          <div className="grid gap-4 sm:grid-cols-2">
            <Input
              id={`${idPrefix}-at`}
              label="Data e hora"
              type="datetime-local"
              value={form.scheduledAt}
              onChange={updateField('scheduledAt')}
              required
              disabled={fieldsDisabled}
            />
            <div>
              <label
                htmlFor={`${idPrefix}-timezone`}
                className="block text-sm font-medium text-slate-700 mb-2"
              >
                Fuso horário
              </label>
              <select
                id={`${idPrefix}-timezone`}
                value={form.timezone}
                onChange={updateField('timezone')}
                disabled={fieldsDisabled}
                className="field-input w-full"
              >
                {TIMEZONE_OPTIONS.map((option) => (
                  <option key={option.value} value={option.value}>
                    {option.label}
                  </option>
                ))}
              </select>
            </div>
          </div>
        ) : (
          <>
            <RecurringScheduleFields
              form={form}
              setFormFields={setFormFields}
              fieldsDisabled={fieldsDisabled}
              idPrefix={idPrefix}
            />
            <div className="grid gap-4 sm:grid-cols-2">
              <Input
                id={`${idPrefix}-ends-at`}
                label="Término (opcional)"
                type="datetime-local"
                value={form.endsAt}
                onChange={updateField('endsAt')}
                disabled={fieldsDisabled}
                hint="Deixe em branco para manter a recorrência ativa por tempo indeterminado."
              />
              <div>
                <label
                  htmlFor={`${idPrefix}-timezone-recurring`}
                  className="block text-sm font-medium text-slate-700 mb-2"
                >
                  Fuso horário
                </label>
                <select
                  id={`${idPrefix}-timezone-recurring`}
                  value={form.timezone}
                  onChange={updateField('timezone')}
                  disabled={fieldsDisabled}
                  className="field-input w-full"
                >
                  {TIMEZONE_OPTIONS.map((option) => (
                    <option key={option.value} value={option.value}>
                      {option.label}
                    </option>
                  ))}
                </select>
                <p className="mt-1.5 text-xs text-content-muted">
                  Usado para calcular o horário dos próximos envios.
                </p>
              </div>
            </div>
          </>
        )}
      </section>
    </>
  );
}

export default ScheduledMessageFormFields;
